__turbopack_context__.v({
  "Cont": "Contact-module-sass-module__nT6xAq__Cont",
  "Contact": "Contact-module-sass-module__nT6xAq__Contact",
  "Copy": "Contact-module-sass-module__nT6xAq__Copy",
  "Main": "Contact-module-sass-module__nT6xAq__Main",
});
